import { Header } from 'header'
import { FC } from 'react'
import { useGetCurrentUser } from '~user-profile/queries/useGetUserById'
import { useSearchMapsInCurrentUserProfile } from '~user-profile/queries/useSearchMaps'
import { UserProfile as View } from 'ui-components'
import { AppProps } from '..'
import { ProfileInfo } from './ProfileInfo'
import { TabBar } from './TabBar'
import { Tab } from './Tabs'

const UserProfile: FC<AppProps> = (props) => {
  const { isLoading: isMapsLoading } = useSearchMapsInCurrentUserProfile(
    props.searchMapsResults
  )
  const { isLoading: isProfileLoading } = useGetCurrentUser(
    props.getUserByIdResults
  )

  return (
    <View
      loading={isMapsLoading || isProfileLoading}
      slots={{
        Header,
        ProfileInfo,
        TabBar,
        Tab
      }}
    />
  )
}

export { UserProfile }
